import './App.css'
import AssessmentReport from './pages/AssessmentReport'
import AssessmentIndividualReport from './pages/AssessmentIndividualReport'
import { AxiosClient } from './apis/configs/AxiosClient'
import Home from './pages/Home'
import AssessmentReportV3 from './pages/AssessmentReportV3'
import AssessmentReportCourses from './pages/AssessmentReportCourses'

function App() {
  const queryParams = new URLSearchParams(window.location.search)
  const assessmentId = queryParams.get('assessmentId')
  const candidateId = queryParams.get('candidateId')
  const v = queryParams.get('v')
  const attemptId = queryParams.get('resultCode') ?? queryParams.get('attemptId')
  const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/'
  const isCoursesRoute = normalizedPath.endsWith('/courses') || queryParams.get('page') === 'courses'
  // console.log('assessmentId', assessmentId)
  console.log('candidateId', candidateId)

  return (
    <AxiosClient>
      {v === '3' && attemptId !== null ? (
        isCoursesRoute ? (
          <AssessmentReportCourses attemptId={attemptId} />
        ) : (
          <AssessmentReportV3 attemptId={attemptId} />
        )
      ) : (
      <div className="container">
        {candidateId === null && assessmentId === null && v !== '3' && <Home />}
        {candidateId === null && assessmentId !== null && v !== '3' && (
          <AssessmentReport assessmentId={assessmentId} />
        )}
        {assessmentId === null && candidateId !== null && v !== '3' && (
          <AssessmentIndividualReport candidateId={candidateId} />
        )}
      </div>
      )}
    </AxiosClient>
  )
}

export default App
